import EditIcon from "@mui/icons-material/Edit";
import { Button, Box, Add } from "@mui/material";
import MUIDataTable from "mui-datatables";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate, NavLink } from "react-router-dom";
import {
  Dialog,
  DialogContent,
  DialogActions,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import Fade from "@mui/material/Fade";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Stack from "@mui/material/Stack";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

const axios = require("axios");
// const api = axios.create({
//     baseURL: "http://localhost:5000/api/"
// })

export default function SectionDisplay() {
  const api = useAxiosPrivate();
  const navigate = useNavigate();
  const [dialog, setDialog] = useState(false);
  const [deleteId, setDeleteId] = useState([]);
  const [deleteAlert, setDeleteAlert] = useState(false);
  const [open, setOpen] = useState(false);

  const columns = [
    { label: "batch", name: "batch_year" },
    { label: "program type", name: "program_type" },
    { label: "admission type", name: "admission_type" },
    { label: "Section", name: "title" ,options :{sort : true}},
    { label: "number of students", name: "no_of_students" },
    { label: "department", name: "department" },
    { label: "id", name: "id", options: { display: false, filter: false } },
    {
      label: "actions",
      name: "delete",
      options: {
        filter: false,
        customBodyRender: (dataIndex, rowIndex, tableMeta, value) => {
          return (
            <div
              style={{ width: "100px", display: "flex", alignItems: "center" }}
            >
              <Button
                onClick={(e) => {
                  navigate("/batch_management/updateSection", {
                    state: { updateId: rowIndex.rowData[6] },
                  });
                  // console.log(data[rowIndex.rowIndex].id)
                }}
              >
                <EditIcon color="primary" />
              </Button>
            </div>
          );
        },
      },
    },
  ];

  // const idsToDelete = rowsDeleted.data.map(d => data[d.dataIndex]);
  // console.log(idsToDelete)
  // for(const c of idsToDelete){
  //     const result = await api.delete(`/deleteSection/${c.batch_id}/${c.title}`)
  //     console.log(result)
  //     const result2 = await api.delete(`deleteSectionGroup/${c.id}`)
  // }
  const handleClose = () => {
    setDialog(false);
  };
  const handleDelete = async () => {
    console.log(deleteId);
    for (let i = 0; i < deleteId.length; i++) {
      const result = await api.delete(`deleteSection/${deleteId[i]}`);
      console.log(result);
      setOpen(true);
    }
    setDeleteAlert(true);
    setDialog(false);
  };

  const options = {
    filterType: "checkbox",
    onRowsDelete: async (rowsDeleted) => {
      let amt = [];
      const idsToDelete = rowsDeleted.data.map((d) => data[d.dataIndex]);
      for (let i = 0; i < idsToDelete.length; i++) {
        amt.push(idsToDelete[i].id);
      }
      console.log(amt);
      setDeleteId(amt);
      setDialog(true);
    },
    sortOrder:{
        name : 'batch_year',
        direction : 'asc'
    }
  };

  const [sections, setSections] = useState([]);
  const getSection = async (req, res) => {
    const b = [];
    const amount = [];
    const result = await api.get("/getSection");
    console.log(result);
    for (const c of result.data) {
      if (c.batch_id !== null) {

        const result = await api.get(`/getBatch/${c.batch_id}`);
    
        res = await api.get(`/getDepartment/${result.data[0].department}`);
        if(c.title==='F') console.log(c.status);
        //if else to filter off batch
        if (result.data[0].isOffBatch === false && c.status !== "inactive") {
          amount.push({
            ...c,
            batch_year: result.data[0].batch_year,
            department: res.data[0].name,
            program_type: result.data[0].program_type,
            admission_type: result.data[0].admission_type,
          });
        }
      }
    }
    console.log(amount);
    for (let i = 0; i < result.data.length; i++) {
      if (amount[i] !== undefined && amount[i].hasOwnProperty("batch_year"))
        b.push({
          ...result.data[i],
          batch_year: amount[i].batch_year,
          program_type: amount[i].program_type,
          admission_type: amount[i].admission_type,
          department: amount[i].department_name,
        });
    }
    console.log(b);

    setSections(amount);
  };

  console.log(sections);
  useEffect(
    (e) => {
      getSection();
    },
    [open]
  );
  const data = sections;

  return (
    <div>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
        }}
      ></Box>
      <Dialog open={dialog} onClose={handleClose}>
        <DialogTitle>{"Are you sure?"}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            are you sure you want to delete these section
          </DialogContentText>
          <DialogActions>
            <div>
              <Button onClick={handleDelete}>ok</Button>
              <Button onClick={handleClose}>cancel</Button>
            </div>
          </DialogActions>
        </DialogContent>
      </Dialog>

      <MUIDataTable
        title={"SECTIONS LIST"}
        data={data}
        columns={columns}
        options={options}
      />
      <Stack sx={{ width: "100%" }} spacing={2}>
        <Fade
          in={deleteAlert}
          timeout={{ enter: 1000, exit: 1000 }}
          addEndListener={() => {
            setTimeout(() => {
              setDeleteAlert(false);
            }, 6000);
          }}
        >
          <Alert>
            <AlertTitle>success</AlertTitle>
            successfully deleted
          </Alert>
        </Fade>
      </Stack>
    </div>
  );
}
